// Navigation des Moduls `techhub` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul techhub.
import {
  Key,
  Package,
  Receipt,
  RocketLaunch,
  SignOut,
  SquaresFour,
  Storefront,
  Tray,
} from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'techhub',
  title: 'Tech Hub',
  nav: {
    people: [
      {
        key: 'techhub.rail',
        label: 'Tech',
        icon: SquaresFour,
        path: '/tech',
        roles: ['ALL'],
        order: 60,
        area: 'rail',
      },
      {
        key: 'techhub.tab.apps',
        label: 'My apps',
        icon: SquaresFour,
        path: '/tech',
        roles: ['ALL'],
        order: 10,
        area: 'tabs:tech',
      },
      {
        key: 'techhub.tab.catalog',
        label: 'Catalog',
        icon: Storefront,
        path: '/tech/catalog',
        roles: ['ALL'],
        order: 20,
        area: 'tabs:tech',
      },
      {
        key: 'techhub.tab.requests',
        label: 'Requests',
        icon: Tray,
        path: '/tech/requests',
        roles: ['ALL'],
        order: 30,
        area: 'tabs:tech',
      },
    ],
    admin: [
      {
        key: 'techhub.inventory',
        label: 'Inventory',
        icon: SquaresFour,
        path: '/tech',
        roles: ['ADM', 'HR', 'CL'],
        order: 510,
        area: 'Tech',
        readOnly: ['HR', 'CL'],
      },
      {
        key: 'techhub.access',
        label: 'Access',
        icon: Key,
        path: '/tech/access',
        roles: ['ADM', 'HR'],
        order: 520,
        area: 'Tech',
        readOnly: ['HR'],
      },
      {
        key: 'techhub.requests',
        label: 'Requests',
        icon: Tray,
        path: '/tech/requests',
        roles: ['ADM'],
        order: 530,
        area: 'Tech',
      },
      {
        key: 'techhub.packages',
        label: 'Packages',
        icon: Package,
        path: '/tech/packages',
        roles: ['ADM', 'HR'],
        order: 540,
        area: 'Tech',
      },
      {
        key: 'techhub.offboarding',
        label: 'Offboarding',
        icon: SignOut,
        path: '/tech/offboarding',
        roles: ['ADM', 'HR'],
        order: 550,
        area: 'Tech',
      },
      {
        key: 'techhub.costs',
        label: 'Costs & renewals',
        icon: Receipt,
        path: '/tech/costs',
        roles: ['ADM', 'CL', 'CEO'],
        order: 560,
        area: 'Tech',
      },
      {
        key: 'techhub.releases',
        label: 'Releases',
        icon: RocketLaunch,
        path: '/tech/releases',
        roles: ['ADM'],
        order: 570,
        area: 'Tech',
      },
    ],
  },
});
